import type {ReactNode} from "react";
import {useEncounter} from "@/encounter/EncounterHooks.ts";
import {usePlayerViewPortSync} from "./usePlayerViewPortSync.ts";
import {PlayerViewPortContext} from "./PlayerViewPortHooks.ts";

export function PlayerViewPortProvider({children}: {children: ReactNode}) {
    const encounter = useEncounter();
    const state = usePlayerViewPortSync(encounter, encounter.viewPort);
    return <PlayerViewPortContext.Provider value={state}>{children}</PlayerViewPortContext.Provider>;
}
